<template>
<v-app id="inspire" class="CSChatThai" style="overflow-y: hidden;background: white;">
  <v-layout row wrap justify-center align-center>
    <v-progress-circular v-if="progress" :size="150" :width="10" style="margin: auto;" indeterminate color="blue"></v-progress-circular>
    <checkconsentOnechatDialog :url_consent="url_consent" :consentOnechatDialog="consentOnechatDialog" @closeDialogConsentOnechat="closeDialogConsentOnechat"></checkconsentOnechatDialog>
    <newConsent :newConsentDialog="newConsentDialog" :newConsentDetail="newConsentDetail" @closeNewConsent="closeNewConsent"/>

  </v-layout>
</v-app>
</template>

<script>
// import Navbar from '@/components/homepage/Navbar'
import checkconsentOnechatDialog from '@/components/chat/dialog/consent/consent_onechat_dialog'
import newConsent from '@/components/consent/new_consent'
import { Encode, Decode } from '@/services'
import { sync } from 'vuex-pathify'
var _ = require('lodash')
var Centrifuge = require('centrifuge')
var centrifuge = new Centrifuge(process.env.WEB_centrifuge)
export default {
  data () {
    return {
      newConsentDialog: false,
      newConsentDetail: {},
      url_consent: '',
      consentOnechatDialog: false,
      progress: true,
      code: '',
      status: '',
      passlogin: '',
      shared_token: '',
    }
  },
  computed: {
    ...sync('*')
  },
  created () {
    this.shared_token = this.$route.query.shared_token
    if (this.shared_token) {
      this.loginWithSharetoken(this.shared_token)
    } else {
      console.log('error: access_denied')
      this.$router.push('/login')
    }
  },
  methods: {
    closeNewConsent (value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
      // set localStorage authorization
      this.progress = true;
      localStorage.setItem('Authenrization', Encode.encode({'tokenuser': value.token, 'status_login': 'T', 'type_user': 'user'}))
        if (localStorage.getItem('botid_redirect') !== null) {
          this.progress = false;
          this.searchFriend(localStorage.getItem('botid_redirect'))
        } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          this.progress = false;
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
          this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
        } else {
          this.progress = false;
          // console.log(`this.isMobile(): ${this.isMobile()}`)
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        }
    },
    closeDialogConsentOnechat (value) {
      this.consentOnechatDialog = value
    },
    connectCentrifuge (token) {
      var me = this
      var events = ''
      var data_msg = ''
      centrifuge.setToken(process.env.centrifuge_key);
      centrifuge.subscribe(token, function(message) {
        console.log(message.data.event)
        events = message.data.event
        if (events === 'consent') {
          // consent close dialog
          me.consentOnechatDialog = false
          me.getOnechatToken(token)
        }
      })
      centrifuge.on('connect', function() {
          console.log("connected centrifuge authen login");
      });
      centrifuge.on('disconnect', function() {
          console.log("disconnected centrifuge authen login");
      });
      centrifuge.connect();
    },
    getOnechatToken (token) {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var hour = String(today.getHours() + 1).padStart(2, '0')
      var minute = String(today.getMinutes()).padStart(2, '0')
      var seconds = String(today.getSeconds()).padStart(2, '0')
      var milsec = today.getMilliseconds()
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00'
        dd = String(today.getDate() + 1).padStart(2, '0')
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1'
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1'
            yyyy = today.getFullYear() + 1
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0')
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
      // console.log(today)
      var expireddate = Date.parse(today)
      // console.log(expireddate)
      var body = Encode.encodeRichmenu({ 'userid': token, 'expired_date': expireddate })
      // console.log(body)
      // console.log(body.split('=')[1]);

      // check new consent
      if (this.$cookie.get(`check-consent-${token}`) === null || this.$cookie.get(`check-consent-${token}`) === undefined) {
        // test new consent
        this.progress = false
        this.newConsentDialog = true
        this.newConsentDetail = {token: token}
      } else {
        this.progress = false
        // set localStorage authorization
        localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
        if (localStorage.getItem('botid_redirect') !== null) {
          this.searchFriend(localStorage.getItem('botid_redirect'))
        } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
          // redirect bot room with url
          var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
          this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
        } else {
          // console.log(`this.isMobile(): ${this.isMobile()}`)
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        }
      }

      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'true') {
      //       this.progress = false
      //       // set localStorage authorization
      //       localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
      //       if (localStorage.getItem('botid_redirect') !== null) {
      //         this.searchFriend(localStorage.getItem('botid_redirect'))
      //       } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
      //         // redirect bot room with url
      //         var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
      //         this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
      //       } else {
      //         if (window.innerWidth <= 960) {
      //           this.$router.push('/mobile/homepage')
      //         } else {
      //           this.$router.push('/chat')
      //         }
      //       }
      //     } else {
      //       // console.log('consentOnechatDialog: ', this.consentOnechatDialog)
      //       // show dialog consent
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //       // clear localStorage autherization
      //       console.log('dialog: ', this.consentOnechatDialog)
      //       // console.log('url: ', this.url_consent)
      //       // localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'F', 'type_user': 'user'}))
      //       localStorage.removeItem('Authenrization')
      //       // this.$router.push({path: '/login', force: true})
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      //   this.progress = false
      // })
    },
    loginWithSharetoken (token) {
      this.progress = true
      var source = {
        shared_token: token
      }
      this.axios.post(process.env.APImanage + '/login_sharedtoken', source).then((response) => {
        this.status = response.data['status']
        this.progress = false
        if (this.status === 'success') {
          var profile = response.data['account']['profile']
          this.myprofilepicture = profile['profilepicture']
          this.myname = profile['name']
          this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
          localStorage.setItem('Authenrization', Encode.encode({'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type']}))
          localStorage.setItem('profilepicture', profile['profilepicture'])
          localStorage.setItem('name', profile['name'])
          localStorage.setItem('phone', profile['phone'])
          localStorage.setItem('email', profile['email'])
          localStorage.setItem('status', profile['status'])
          localStorage.setItem('type_user', profile['type'])
          localStorage.setItem('wallpaperInfo', JSON.stringify({
            'info': [{
              'room': '',
              'background': ''
            }]
          }))
          this.progress = false
          // connect centrifuge
          this.connectCentrifuge(profile['tokenuser'])
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            this.getOnechatToken(profile['tokenuser'])
          } else {
            this.$router.push(localStorage.getItem('pathRoom'))
          }
        } else {
          this.$cookie.set('status_login', 'F')
          this.progress = false
          if (response.data['message'] === 'The request is missing a required parameter, includes an invalid parameter value, includes a parameter more than once, or is otherwise malformed.') {
            this.logout()
          } else {
            this.$router.push('/not_found')
          }
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    logout () {
      localStorage.clear()
      var logouturl = this.$cookie.get('logouturl')
      if (process.env.LogoutOneid) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          window.open(process.env.LogoutOneid, '_parent')
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          this.$router.push({path: '/login', force: true})
        }
      }
    },
    searchFriend (botid) {
      var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      this.axios.post(process.env.APIsearchfriend, {
        tokenbot: botid,
        tokenuser: decoded.tokenuser
      }).then((response) => {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          localStorage.removeItem('botid_redirect')
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            localStorage.removeItem('botid_redirect')
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom)
            } else {
              this.$router.push('/chat/room/' + response.data.listuser.user.tokenroom)
            }
          } else {
            console.log('not friend')
            this.$router.push('/addbot/' + localStorage.getItem('botid_redirect'))
          }
        }
      }).catch(error => {
        console.log(error)
        localStorage.removeItem('botid_redirect')
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage')
        } else {
          this.$router.push('/chat')
        }
      })
    }
  },
  components: {
    // Navbar,
    checkconsentOnechatDialog,
    newConsent
  }
}
</script>
<style type="text/css" scoped>
>>>.v-messages__message {
  margin-bottom: 2px;
  margin-top: 2px;
  line-height: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}
>>>.error--text {
  color: #ff7979 !important;
  caret-color: #ff7979 !important;
}
.forgetpass {
  color: white !important;
  cursor: pointer !important;
}
.forgetpass:hover {
  color: white !important;
  cursor: pointer !important;
  text-decoration: underline !important;
}
a:link {
    text-decoration: none;
    color: white !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #2562af !important;
    text-decoration: none;
}

a:active {
    color: white !important;
    text-decoration: none;
}
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: white !important;
   color: white;
   text-align: center;
}
.footermo {
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000 !important;
   color: white;
   text-align: center;
   margin-top: 20px;
}
.application .theme--light.card, .theme--light .card {
    background-color:  #2562af !important;
}
html, body {
  overflow: scroll;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.btnloginmobile {
  /* width: 30%; */
  width: 125px !important;
  font-size: 14px;
  color: white !important;
  margin-top: 1vh !important;
  background-color: #2562af!important;
  border: 2px solid white;
  border-radius: 30px;
}
.btnloginmobile:disabled {
  width: 125px !important;
  font-size: 14px;
  /* color: white !important; */
  margin-top: 1vh !important;
  background-color: #5f9cea !important;
  border-radius: 30px;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  border-color: #5e9cea !important;
  background-color: #5f9cea!important;
}
.btnregismobile {
  width: 30%;
  font-size: 14px;
  color: #2562af !important;
  margin-top: 1vh !important;
  background-color:#FBFBFF !important;
  border-radius: 10px;
}
.btnloginweb {
  color: white !important;
  width:40%;margin-top: 1vh !important;
  background-color: #2562af !important;
  /*border-radius: 10px;*/
  border: 2px solid white;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
.btnregisweb {
  color: #2562af !important;
  width:40%;margin-top: 1vh !important;
  background-color:#FBFBFF !important;
  border-radius: 10px;
  font-family: 'CS ChatThaiUI' !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}


>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12) !important;
    border-radius: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginWithSharedToken.vue